module.exports = __webpack_public_path__ + "img/spinner.c09255da.svg";